// start:ng42.barrel
export * from './categories.service';
// end:ng42.barrel

